'use client';

import {
  AlertTriangle,
  LayoutGrid,
  ScrollText,
  type LucideIcon,
} from 'lucide-react';

import {
  ConceptsSection,
  HelpPage,
  IntroSection,
  RolesSection,
  TasksSection,
} from '@/components/help';
import { useTranslation } from '@/hooks/useTranslation';

const TASK_ICONS: Record<string, LucideIcon> = {
  overview: LayoutGrid,
  emergencyBypass: AlertTriangle,
  auditLogs: ScrollText,
};

const TASK_PATHS: Record<string, string> = {
  overview: '/iam-admin',
  emergencyBypass: '/iam-admin/emergency-bypass',
  auditLogs: '/iam-admin/audit-logs',
};

export default function IamAdminHelpPage() {
  const { t } = useTranslation();
  const help = t.iamAdmin.help;

  return (
    <HelpPage title={help.title} subtitle={help.subtitle}>
      <IntroSection
        title={help.intro.title}
        paragraph={help.intro.paragraph}
        highlights={help.intro.highlights}
      />

      <ConceptsSection
        title={help.concepts.title}
        description={help.concepts.description}
        items={help.concepts.items}
      />

      <RolesSection
        title={help.roles.title}
        description={help.roles.description}
        columnHeaders={help.roles.columnHeaders}
        items={help.roles.items}
      />

      <TasksSection
        title={help.tasks.title}
        description={help.tasks.description}
        cards={help.tasks.cards.map((c) => ({
          ...c,
          path: TASK_PATHS[c.id] ?? '#',
          icon: TASK_ICONS[c.id],
        }))}
      />
    </HelpPage>
  );
}
